import script from "./FavouritesItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FavouritesItem.vue?vue&type=script&setup=true&lang=js"

import "./FavouritesItem.vue?vue&type=style&index=0&id=546191de&lang=scss"

const __exports__ = script;

export default __exports__